import React, { useEffect, useRef, useState } from "react"
import { message, Space, Tooltip } from "antd"

import TableCustom from "src/components/Table/CustomTable"
import ButtonCircle from "src/components/MyButton/ButtonCircle"
import CB1 from "src/components/Modal/CB1"
import IconBase from "src/components/IconBase"
import PopupAction from "src/components/PopupAction"
import Notice from "src/components/Notice"
import dayjs from "dayjs"

import STORAGE, { getStorage } from "src/lib/storage"
import WarehouseService from "src/services/WarehouseService"
import ViewDetailModal from "../../SimWarehouse/Modal/ViewDetailModal"
import ModalCreate from "../../SimWarehouse/Modal/ModalCreate"
import ModalCreateData from "../../DataProposal/Modal/ModalCreateData"
import ModalDetailData from "../Modal/ModalDetailWareHouseData"
import FilterIn from "../../SimWarehouse/components/FilterIn"
import FilterData from "./FilterData"

const MODAL_ACTION = {
  view: { type: "view", title: "Xem thông tin khách hàng" },
  edit: { type: "edit", title: "Chỉnh sửa thông tin khách hàng" },
}

function DataEntry(props) {
  const [dataSource, setDataSource] = useState([])
  const [dataSelected, setDataSelected] = useState([])
  const [isModalAction, setIsModalAction] = useState({})
  const permissions = localStorage.getItem(STORAGE.PERMISSIONS) || ""
  const [searchTerm, setSearchTerm] = useState("")
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [isViewModalOpen, setIsViewModalOpen] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const [summary, setSummary] = useState({})
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  })
  const [filter, setFilter] = useState({})
  const [keyword, setKeyword] = useState("")

  const handleAction = (actionType, ID, record) => {
    if (actionType === "view") {
      setSelectedRecord(record)
      setIsViewModalOpen(true)
    }
  }

  useEffect(() => {
    fetchData(filter, keyword)
  }, [pagination.current, pagination.pageSize, filter, keyword])

  const fetchData = async (filter = {}, keyword) => {
    setLoading(true)
    const finalFilter = {
      type: "1",
      ...filter,
    }
    try {
      const response = await WarehouseService.listData({
        page: pagination.current,
        per_page: pagination.pageSize,
        filter: finalFilter,
        keyword,
      })
      const users = response?.success?.data || []
      const total = response?.success?.total || users.length
      const current = response?.success?.current_page
      const perPage = response?.success?.per_page
      const filteredData = response?.success?.data || []
      setPagination({
        current,
        pageSize: perPage,
        total,
      })
      setSummary({
        totalAccounts: total,
      })
      props.setFilter(filter)
      setDataSource(filteredData)
    } catch (error) {
      message.error("Lỗi khi tải dữ liệu.")
    } finally {
      setLoading(false)
    }
  }

  // const handleOpenModal = () => {
  //   setIsModalOpen(true);
  // };
  // Cột bảng phiếu nhập kho
  const columns = [
    // {
    //   title: "STT",
    //   dataIndex: "index",
    //   key: "index",
    //   render: (_, record, i) => {
    //     return <>{i + 1}</>
    //   },
    // },
    {
      title: "Mã lô nhập",
      dataIndex: "batch_code",
      key: "batch_code",
      align: "center",
    },

    {
      title: "Nhà cung cấp",
      dataIndex: "supplier",
      align: "center",
      key: "supplier",
      render: supplier => supplier?.name || "",
    },
    {
      title: "Nhà mạng",
      dataIndex: "network",
      align: "center",
      key: "network",
      render: network => network?.name || "",
    },
    {
      title: "Quốc gia",
      dataIndex: "country",
      align: "center",
      key: "country",
      render: country => country?.title || "",
    },
    {
      title: "Dung lượng Data",
      dataIndex: "total_data",
      align: "center",
      key: "total_data",
    },
    {
      title: "Data còn lại",
      dataIndex: "data_remaining",
      align: "center",
      key: "data_remaining",
    },
    {
      title: "Đơn giá Data",
      dataIndex: "unit_price",
      key: "unit_price",
      render: text => Number(text).toLocaleString("en-US"),
      align: "right",
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Tổng tiền",
      dataIndex: "total_amount",
      key: "total_amount",
      render: text => Number(text).toLocaleString("en-US"),
      align: "right",
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Loại chiết khấu",
      dataIndex: "discount_type",
      align: "center",
      key: "discount_type",
      render: text => {
        if (text === "percent") {
          return "Chiết khấu %"
        } else if (text === "fixed") {
          return "Chiết khấu giá tiền"
        }
        return text
      },
    },
    {
      title: "Chiết khấu",
      dataIndex: "discount",
      align: "center",
      key: "discount",
      render: text => Number(text).toLocaleString(),
    },
    {
      title: "Tiền sau chiết khấu",
      dataIndex: "total_discord",
      key: "total_discord",
      render: text => Number(text).toLocaleString("en-US"),
      align: "right",
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Ngày nhập kho",
      dataIndex: "approved_at",
      align: "center",
      key: "approved_at",
      render: text => {
        return dayjs(text).isValid() ? dayjs(text).format("DD-MM-YYYY") : ""
      },
    },
    {
      title: "Người duyệt",
      dataIndex: "proposed",
      align: "center",
      key: "proposed",
      render: proposed => proposed?.fullname || "",
    },
    // {
    //   title: "Trạng thái",
    //   dataIndex: "type",
    //   key: "type",
    //   render: (type) => {
    //     const isApproved = Number(type) === 1;
    //     return (
    //       <span style={{ color: isApproved ? "green" : "red", fontWeight: 500 }}>
    //         {isApproved ? "Đã duyệt" : "Chưa duyệt"}
    //       </span>
    //     );
    //   },
    // },
    {
      title: <Tooltip title={"Hành động"}>_</Tooltip>,
      dataIndex: "action",
      key: "action",
      align: "center",
      fixed: "right",
      render: (_, record) => {
        return (
          <PopupAction>
            <div
              onClick={() => {
                handleAction("view", record.ID, record)
              }}
            >
              <IconBase name="eye" />
              <span>Xem chi tiết</span>
            </div>
          </PopupAction>
        )
      },
    },
  ]
  const fetchWarehouseIn = async (page = 1, pageSize = 50) => {
    try {
      const response = await WarehouseService.listWarehouseIn({
        page,
        pageSize,
      })

      const warehouseIns = response?.success?.data || []
      const total = response?.success?.total || warehouseIns.length

      const dataSource = warehouseIns.map(item => ({
        ...item,
        unit_price: Number(item.unit_price || 0).toLocaleString(),
        discount: Number(item.discount || 0).toLocaleString(),
      }))

      setDataSource(dataSource)
      setData(dataSource)
      setPagination(prev => ({
        ...prev,
        current: page,
        total,
      }))
    } catch (error) {
      console.error("Lỗi khi lấy danh sách phiếu xuất kho", error)
      message.error("Không thể lấy danh sách phiếu xuất kho")
    }
  }

  const handleTableChange = newPagination => {
    setPagination({
      ...pagination,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    })
  }

  return (
    <div>
      {!!dataSelected.length && (
        <ButtonCircle
          style={{ marginRight: "10px", marginBottom: "10px" }}
          title={`Xóa ${dataSelected.length} hàng đã chọn`}
          iconName="delete-outline"
          onClick={() => {
            if (dataSelected.length === 0) {
              message.warning("Vui lòng chọn ít nhất một bản ghi để xóa.")
              return
            }

            CB1({
              title: `Bạn có chắc chắn muốn xoá <strong>${dataSelected.length}</strong> bản ghi không?`,
              icon: "trashRed",
              okText: "Đồng ý",
              onOk: async close => {
                const idsToDelete = dataSelected.map(item => item.ID)
                try {
                  const response = await WarehouseService.deleteData({
                    ids: idsToDelete,
                  })

                  // Dùng message nếu không có field "success"
                  if (response?.message?.toLowerCase().includes("thành công")) {
                    message.success("Xóa dữ liệu thành công!")
                    fetchData() // Refresh lại danh sách
                    setDataSelected([]) // Reset selected nếu cần
                  } else {
                    message.error("Xóa dữ liệu thất bại.")
                  }
                } catch (error) {
                  console.error("Lỗi khi xóa:", error)
                  message.error("Lỗi khi xóa dữ liệu.")
                }
                close()
              },
            })
          }}
        />
      )}
      {/* <TableCustom
                isPrimary
                columns={column}
                dataSource={dataSource}
                showPagination
                rowSelection={{
                    type: "checkbox",
                    ...rowSelection,
                }}
                footerLeft={<div className="d-flex mt-20" />}
                widthScroll={1200}
                textEmpty="Không có dữ liệu!"
                scroll={{ x: "max-content" }}
            /> */}

      <FilterData
        filter={filter}
        setFilter={setFilter}
        setKeyword={setKeyword}
      />
      <div style={{ display: "flex", flexDirection: "row", margin: "10px 0" }}>
        <div style={{ padding: "0 5px", color: "#007BFF" }}>
          <strong>Tổng số: {summary.totalAccounts}</strong>
        </div>
      </div>

      <TableCustom
        // rowKey="ID"
        // showPagination={true}
        // rowSelection={{
        //   type: "checkbox",
        //   ...rowSelection,
        // }}
        isPrimary
        columns={columns}
        dataSource={dataSource}
        loading={loading}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: summary.totalAccounts,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],
        }}
        onChange={handleTableChange}
        bordered
        scroll={{ x: "max-content" }}
      />
      {isViewModalOpen && (
        <ModalDetailData
          open={isViewModalOpen}
          onCancel={() => setIsViewModalOpen(false)}
          record={selectedRecord}
          refresh={setRefresh}
        />
      )}
      {/* <ModalCreateData
        open={isUpdateModalOpen}
        onCancel={() => setIsUpdateModalOpen(false)}
        record={selectedRecord}
      /> */}
      {/* <ModalCreateData
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onSubmit={(values) => {
          setIsModalOpen(false);
          // fetchUsers();
        }}
      /> */}
    </div>
  )
}

export default DataEntry
